// extracted by mini-css-extract-plugin
export default {"modal_mensage":"Dialog_modal_mensage__Gfkaa","box_mensage":"Dialog_box_mensage__Gwcds","dialog":"Dialog_dialog__i82Ga","buttons":"Dialog_buttons__IdQA9"};